import { view } from "../../../views/mapView/MapView"
import Legend from "@arcgis/core/widgets/Legend";

const LegendVM=async(view,container,layers)=>{
    const legend = await view.when(()=>{
        let layerList = layers.map(layer=>{
            
            return {layer:layer}
        })
        const widget = new Legend({
            container: container,
            view: view,
            layerInfos: layerList,
        });
        return widget
    })
    return legend
}

export default LegendVM